export const serviceKindPresentation: Record<string, { title: string; description: string }> = {
  LAB: { title: "Lab", description: "รายการตรวจทางห้องปฏิบัติการ" },
  SUPPLY: { title: "Supply", description: "เวชภัณฑ์ / อุปกรณ์สิ้นเปลือง" },
  DRUG: { title: "Drug", description: "ยา" },
  IMAGING: { title: "Imaging", description: "ตรวจทางรังสี / ภาพถ่าย" },
  TREATMENT: { title: "Treatment", description: "หัตถการ / การรักษา" },
  MISCELLANEOUS: { title: "Miscellaneous", description: "ค่าบริการอื่น ๆ" },
  DOCTOR_FEE: { title: "Doctor Fee", description: "ค่าธรรมเนียมแพทย์" },
  ROOM_RATE: { title: "ROOM RATE", description: "ค่าห้องพัก" },
  NURSE_RATE: { title: "NURSE RATE", description: "ค่าบริการทางการพยาบาล" },
  FOOD_TYPE: { title: "FOOD TYPE", description: "ค่าอาหาร" },
};

export const serviceSectionTitles: Record<string, string> = {
  LAB: "ข้อมูลการตรวจ (Lab)",
  SUPPLY: "ข้อมูลเวชภัณฑ์ (Supply)",
  IMAGING: "ข้อมูลรังสี (Imaging)",
  TREATMENT: "ข้อมูลหัตถการ (Treatment)",
  DOCTOR_FEE: "ข้อมูลค่าธรรมเนียมแพทย์ (Doctor Fee)",
  ROOM_RATE: "ข้อมูลห้องพัก (Room rate)",
  NURSE_RATE: "ข้อมูลค่าบริการพยาบาล (Nurse rate)",
  FOOD_TYPE: "ข้อมูลอาหาร (Food Type)",
};

export const serviceFieldHints: Record<string, string> = {
  create_package:
    "เมื่อกดบันทึก ระบบจะสร้างรายการนี้ และไปยังหน้าสร้าง Package ใหม่ โดยนำชื่อ ราคา และรายการสินค้านี้ไปใส่ให้อัตโนมัติ",
  is_affiliate_exclusive:
    "รายการนี้จะแสดงและสั่งซื้อได้เฉพาะผ่านช่องทางพันธมิตร (Affiliate) เท่านั้น",
  is_vat_applicable:
    "ติ๊กเมื่อรายการนี้ต้องคิด VAT · ไม่ต้องติ๊กหากเป็นสินค้า/บริการทางการแพทย์ที่ได้รับยกเว้น VAT",
  is_child_lab: "เลือกเมื่อรายการนี้เป็นรายการย่อยของ Lab อื่น แล้วระบุ Lab แม่ที่ต้องการผูก",
  bill_mode: "หมวดค่าใช้จ่ายที่ใช้แสดงในใบเสร็จ / ใบแจ้งหนี้",
  price_normal: "ราคาปกติสำหรับสินค้าหรือบริการ",
  price_special: "ราคาพิเศษสำหรับสินค้าหรือบริการ",
  price_premium: "ราคาพรีเมียมสำหรับสินค้าหรือบริการ",
  price_foreign: "ราคาสำหรับผู้รับบริการชาวต่างชาติ",
};

export const serviceKindFieldHints: Record<string, Record<string, string>> = {
  LAB: { lab_tmlt: "Lab CataLog code" },
  SUPPLY: {
    mode: "โหมดการใช้งานของเวชภัณฑ์",
    base_unit: "หน่วยย่อยสุดที่ใช้ได้ เช่น ชิ้น อัน",
    stock_unit: "หน่วยย่อยที่สุดที่ขายได้ เช่น ถุง หรือ แพ็ค",
  },
};
